export class TypeDalle {

    tpd_id: string;
    tpd_code: string;
    tpd_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tpd_id                     = data['tpd_id'] ? data['tpd_id'] : null;
        this.tpd_code                   = data['tpd_code'] ? data['tpd_code'] : null;
        this.tpd_libelle                = data['tpd_libelle'] ? data['tpd_libelle'] : null;
    }

}
